import { render } from "./PasswordResetForm.vue?vue&type=template&id=dea5a8ce"
import script from "./PasswordResetForm.vue?vue&type=script&lang=js"
export * from "./PasswordResetForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__